<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page " v-else-if="loaded" >
        
        <div class="row col-12 font-size-14 mr-0 ml-0 pl-5 pr-5 mt-4" >
            <div class="col-12 col-md-4 mt-1 mb-1 p-0 p-md-1 " >
                
                <div class="row" >
    
                    <div class="col-auto" > <span class="h4 font-900 d-inline" style="line-height: 34px; margin-rigth: 15px" > Group results by:  </span> </div>
                    <div class="col" >
                        <multiselect v-model="groupBy" :options="groupResults" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Group results by:"  @input="parseFilteredConversions" class="d-inline-block w-100" :allow-empty="false" >
                    </multiselect>      
                    </div> 
                    
                </div> 
                
            </div>

        </div>
                
        <engagementLeads v-if="tableLoaded && groupBy.value == 'none'" :data="tableData"  ></engagementLeads>
        
        <engagementSources v-else-if="tableLoaded && groupBy.value != 'none'" :data="tableData"  ></engagementSources>
        
        
    </div> <!-- .page -->

</template>

<script>
//import modal from '@/components/modal.vue'    

import firebase from "firebase";
import Cookies from 'js-cookie'
import moment from 'moment'  

import helper from '@/helpers/helpers.js';    
import engagementLeads from '@/components/engagement-leads.vue'        
import engagementSources from '@/components/engagement-source.vue'        
    
export default {
    name: 'orders',
    components:{
        engagementLeads,
        engagementSources,
        modal: () => import('@/components/modal.vue')
    },
    props: {
        data: { 
            type: [Array],
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            modalState : false,
            modalData: null,
            
            groupResults: [
                
                {
                    text: "None",
                    value: "none"
                },
                {
                    text: "Source",
                    value: 'source'
                },
                {
                    text: "Previous URL",
                    value: 'previousURL'
                }
                
            ],
            groupBy: {
                text: "None",
                value: "none"
            },
            
            tableLoaded: false,
            tableData:[ ]

        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        this.data.forEach((item)=>{
            //let url = (new URL( item.referralURL ));
            let url = item.referralURL
            let queryString = url.split("?")[1]
            
            
            let parameters = []
            if( typeof queryString == 'string' && queryString != undefined ){
                let queryStringArray = queryString.split("&")
                //console.log(  queryStringArray )
                
                queryStringArray.forEach((parameter)=>{
                    let key = parameter.split("=")[0]
                    let value = parameter.split("=")[1]
                    if( key != 'email' ){
                        parameters.push( { key: key, value: value } )

                        let found = this.groupResults.find(el => el.value == key )
                        if( found == undefined ){
                             this.groupResults.push( { text: key+" parameter", value: key } )
                        }
                    }
                        
                })
                //if( item.referralURL.includes( 'utm_medium' ) )
                
            }
            item.parameters = parameters
                
        })
        //console.log(this.data)
        
        this.parseFilteredConversions()
        
    },
    beforeDestroy() {
    },
    methods: {
        returnDate(a){
            //let timezone = helper.getAccountTimezone()   
            //return this.$moment.unix(a.datetime).tz(timezone).format( 'MMM D, HH:mm:ss' )
            return helper.formatDate( a.datetime )
        },
        renderTag(field){
            return field.tag
        },
        returnShortString(link, type){
            let limit = 65
            if( link != null ){
                if( link.length > limit ){
                    return link.substring(0,limit) + "..."
                }else{
                    return link
                }
            }else{
                return ''
            }
                
            
        },
        routeUser(params){
            console.log(params)
            let leadID = params.row.leadID
            this.fModalOpen( 'lead', leadID );
        },
        fModalOpen( target, data ){
            if( target == 'source' ){
                this.selectedSource = data.orders
            }else{
                this.modalData = data
            }
            this.modalState = true
        },
        
        parseFilteredConversions(){
            
            this.tableLoaded = false
            
            this.tableData = []
            
            if( this.groupBy.value == 'none' ){
                this.data.forEach((item)=>{ this.tableData.push(item) })
                this.tableData.sort((a, b) => a.datetime - b.datetime);
            }else if( this.groupBy.value == 'source' ){
                this.groupResultsBy( 'source', this.data );
                this.tableData.sort((a, b) => b.engagements.length - a.engagements.length);
            }else if( this.groupBy.value == 'previousURL' ){
                this.groupResultsBy( 'previousURL', this.data );
                this.tableData.sort((a, b) => b.engagements.length - a.engagements.length);
            }else if( this.groupBy.text.includes('parameter') ){
                this.groupResultsBy( this.groupBy.value, this.data );
                this.tableData.sort((a, b) => b.engagements.length - a.engagements.length);
            }
            
            //console.log( this.tableData )
            
            this.loaded = true;
            this.tableLoaded = true;
            
        },
        
        groupResultsBy( type, data ){
            
            let results = helper.groupResultsBy( type, data )
            
            //console.log(results)
            results.forEach((item)=>{ this.tableData.push( item ) })
            return results
            
        }
    },
    computed: {
        matches() {
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if (row['name'].toLowerCase().includes(this.filter.toLowerCase())) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
        ID: function(){
            if( typeof this.ID == 'string' ){
                this.docID = this.ID
            }else{
                this.data = this.ID
            }
    
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/engagement.vue